const postState = () => ({
  id: '',
  tags: [],
  readTimeColor: '',
});

const mutations = {
  setCurrentPostId(state, data) {
    state.id = data;
  },
  setCurrentPostTags(state, data) {
    state.tags = data;
  },
  setReadTimeColor(state, data) {
    state.readTimeColor = data;
  },
};

const actions = {
  setCurrentPostId({ commit }, data) {
    commit('setCurrentPostId', data);
  },
  setCurrentPostTags({ commit }, data) {
    commit('setCurrentPostTags', data);
  },
  setReadTimeColor({ commit }, data) {
    commit('setReadTimeColor', data);
  },
};

export default () => ({
  state: postState(),
  mutations,
  actions,
});
